import { createContext } from 'react';

export const ReportSelectionContext = createContext({
  consumer: 'DEFAULT',
  truncationLength: 0,
});
